module.exports = __webpack_public_path__ + "static/media/back7.4dfdff20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backs/back7.jpg
// module id = 442
// module chunks = 0